<template>
	<App title="Update Warehouse">
		<div class="w-100 position-relative">
		<div class="update-layout">

			<!-- ── Hero ──────────────────────────────────────────────────── -->
			<div class="update-hero">
				<div class="update-avatar">
					<i class="fas fa-warehouse"></i>
				</div>
				<div class="update-hero-info">
					<h2 class="update-name">{{ warehouse.title }}</h2>
					<span class="update-role-badge">{{ warehouse.state || 'Warehouse' }}</span>
				</div>
				<div class="update-hero-actions">
					<a :href="route('warehouse.page.group')" class="btn btn-sm btn-outline-secondary">
						<i class="fas fa-arrow-left me-1"></i> Back
					</a>
				</div>
			</div>

			<!-- ── Form card ──────────────────────────────────────────────── -->
			<div class="update-card">
				<div class="update-card-header">
					<i class="fas fa-warehouse me-2 text-muted"></i>
					<span>Warehouse Details</span>
				</div>

				<Form ref="form" @submit="onSubmit">
					<div class="update-form-grid">

						<div class="update-field update-field--full">
							<label for="title" class="update-label">Warehouse Name</label>
							<InputField id="title" v-model="title" name="title" rules="required" label="Warehouse Name" placeholder="Input warehouse name .." />
						</div>

						<!-- <div class="update-field">
							<label for="manager" class="update-label">Manager</label>
							<SelectField id="manager" v-model="manager" name="manager" rules="required" :options="manager_options" />
						</div> -->

						<div class="update-field">
							<label for="country" class="update-label">Country</label>
							<SelectField id="country" v-model="country" name="country" rules="required" :options="type_options">
								<option value="Nigeria" selected>Nigeria</option>
							</SelectField>
						</div>

						<div class="update-field">
							<label for="state" class="update-label">State</label>
							<SelectField id="state" v-model="state" name="state" label="Select State" :options="state_options" />
						</div>

						<div class="update-field update-field--full">
							<label for="address" class="update-label">Address</label>
							<InputField id="address" v-model="address" name="address" rules="required" label="Address" placeholder="123 Main Street" />
						</div>

					</div>

					<!-- ── Actions ─────────────────────────────────────────── -->
					<div class="update-form-actions">
						<button type="button" class="btn btn-outline-danger" @click="goBack">
							<i class="fas fa-times me-1"></i> Cancel
						</button>
						<Button id="action" type="submit" :label="labels" :loading="loading" :done="done" class="btn btn-primary" :disabled="checkInput" />
					</div>
				</Form>
			</div>

		</div>

		<div class="mt-9 position-absolute top-0 end-0">
			<NotivueKeyboard v-slot="{ containersTabIndex }">
				<Notivue v-slot="item" :containersTabIndex="containersTabIndex">
					<AppNotification :item="item" />
				</Notivue>
			</NotivueKeyboard>
		</div>
		</div>
	</App>
</template>

<script lang="ts">
import $ from 'jquery'
import banks from '@/json/banks.json' // Your JSON file
import { useConfirm } from '@/libs/useConfirm.ts'
import locations from '@/json/location.json' 
import { error } from '@/ts/app'
import Swal from 'sweetalert2'
import Alert from '@/vue/components/Alert.vue'
import Block from '@/vue/components/Block.vue'
import Button from '@/vue/components/Button.vue'
import Form from '@/vue/components/Form.vue'
import InputField from '@/vue/components/InputField.vue'
import SelectField from '@/vue/components/SelectField.vue'
import App from '@/vue/templates/App.vue'
import { ButtonLabel } from '@/vue/utils/Button'
import { Options as Select2Options } from 'select2'
import { Component, Prop, Ref, Vue, Watch, toNative } from 'vue-facing-decorator'
import { Notivue, Notification, push, materialTheme, NotificationProgress, NotivueKeyboard  } from 'notivue'
import AppNotification from '@/vue/components/AppNotification.vue'

@Component({
	components: {
		App,
		Form,
		Alert,
		InputField,
		Button,
		Block,
		SelectField,
		Notivue,
		Notification,
		NotificationProgress,
		AppNotification,
		NotivueKeyboard
	
	},
})
class Create extends Vue {
	message = ''
	confirm = useConfirm().confirm
	loading = false
	done = false
	state = ''
	title = ''
  country = ''
	address = ''
	manager = ''
	//type =  ''
	//zone = ''
	

	materialTheme = materialTheme

    @Prop({type:Object})
    readonly warehouse
	@Prop({ type: Array })
	readonly types!: Array<{ name: string; value: string }>

	@Ref('form')
	readonly form!: InstanceType<typeof Form>
	@Ref('bankField') 
    bankField!: any

/*
	@Ref('alert')
	readonly alert!: InstanceType<typeof Alert>

	@Watch('message')
	onMessageChanged(value: string) {
		if (value.length > 0) {
			this.alert.show()
		} else {
			this.alert.hide()
		}
	}
*/

	/*get banks_options(): Select2Options {
		return {
			ajax: null,
			placeholder: 'Select Bank',
			minimumResultsForSearch: Infinity,
			data: banks.map((bank, i) => ({
				id: bank.name, // just the code
				text: bank.name,
			})),
		}
	}
*/
	get labels(): ButtonLabel {
		return {
			normal: 'Update Warehouse',
			loading: 'updating...',
			done: 'Updated',
		}
	}


	get manager_options(): Select2Options {
		return {
			placeholder: 'Select Warehouse Manager',
			minimumResultsForSearch: Infinity,
			ajax: {
				method: 'get',
				url: this.route('admin.ajax.select.admin'),
			},
			//@ts-ignore
			templateResult: ({ id, fullname, email, text }) => (id ? $(`<span>${fullname} &nbsp; (${email})</span>`) : text),
			//@ts-ignore
			templateSelection: ({ id, fullname, email, text }) => (id ? $(`<span>${fullname} &nbsp; (${email})</span>`) : text),
		}
	}

	get type_options(): Select2Options {
		return {
			placeholder: 'Select Country',
			minimumResultsForSearch: Infinity,
			//@ts-ignore
			ajax: null,
		}
	}

get state_options(): Select2Options {
		const nigeria = locations.data.find(loc => loc.country === 'Nigeria')
		return {
			ajax: null,
			placeholder: 'Select State',
			minimumResultsForSearch: Infinity,
			data: nigeria
			? nigeria.states.map((state, index) => ({
				id: state, // or use `state` directly if needed
				text: state
				}))
			: [],
		}
	}


	async confirmAction() {
		
		const isConfirmed = await this.confirm(
			'Are you sure you want to cancel this operation?',
			{
			title: 'Cancel Process',
			confirmText: 'Yes, Cancel',
			cancelText: 'No, Continue',
			}
		)
			
			if (!isConfirmed) return
			
			setTimeout(()=>{
				this.loading = false
				this.router.visit(this.route('warehouse.page.group'))
			},300)
		
		}
	get checkInput(): boolean {
	return [this.title, this.address, this.country, this.state]
		.some(field => field.trim() === '')
	}

    created() {
		console.log('Warehouse manager:', this.warehouse.manager)
		this.title = this.warehouse.title;
		this.address = this.warehouse.address;
        this.$nextTick(()=>
            setTimeout(()=>{
                this.state = this.warehouse.state;
				this.country = this.warehouse.country
				this.manager = this.warehouse.manager?.fullname
            },200)
        )
		
       // this.country = this.warehouse.country
		//this.account.bank ="9Japay Microfinance Bank";
	

		
	}

	showToast(message: string, type: 'success' | 'error' ) {
			Swal.fire({
				toast: true,
				position: 'top-end', 
				icon: type, 
				title: message,
				showConfirmButton: false, 
				timer: 5000, 
				timerProgressBar: true,
				didOpen: (toast) => {
					// Pause the timer when the mouse hovers over the toast
					toast.addEventListener('mouseenter', Swal.stopTimer)
					// Resume the timer when the mouse leaves
					toast.addEventListener('mouseleave', Swal.resumeTimer)
				}
			})
		}


	async onSubmit(payload) {
		this.loading = true
		this.message = ''
	
		this.$http
			.put(this.route('warehouse.ajax.update',{warehouse :this.warehouse.slug}), payload)
			.then((response) => {
				this.done = true
				this.message = response.data.message || 'Warehouse created successfully!'
				Swal.fire({
						title: 'Success!',
						text: this.message,
						icon: 'success',
						confirmButtonText: 'OK',
					}).then(() => {
						this.router.visit(this.route('warehouse.page.group'))
						this.message = ''
						Swal.close()
						
					})
				
				
			})
			.catch((e) => {
			
			if (e.response && e.response.data && e.response.data.errors) {
				const errorMsg = e.response.data.errors.title 
					? e.response.data.errors.title[0] 
					: (e.response.data.message || 'An error occurred.');
					
				this.showToast(errorMsg, 'error');
			} 
		
			else if (e.message) {
				this.showToast(e.message, 'error');
			} 
			else {
				this.showToast('Something went wrong. Please try again.', 'error');
			}
		})
			.finally(() => (this.loading = false))
	}

	goBack() {
		window.history.back()
	}
}

export default toNative(Create)
</script>

<style scoped lang="scss">
.update-layout {
	max-width: 760px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
}

// ─── Hero ──────────────────────────────────────────────────────────────────
.update-hero {
	display: flex;
	align-items: center;
	gap: 1.25rem;
	background: #fff;
	border-radius: 12px;
	padding: 1.5rem 1.75rem;
	border: 1px solid #e9ecef;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
	flex-wrap: wrap;
}

.update-avatar {
	flex-shrink: 0;
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background: linear-gradient(135deg, #1e3a2f, #3a7d52);
	color: #fff;
	font-size: 1.35rem;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 4px 12px rgba(30, 58, 47, 0.25);
}

.update-hero-info {
	flex: 1;
	min-width: 0;
}

.update-name {
	font-size: 1.15rem;
	font-weight: 700;
	color: #111827;
	margin-bottom: 0.3rem;
	line-height: 1.2;
}

.update-role-badge {
	display: inline-block;
	padding: 0.2rem 0.7rem;
	border-radius: 999px;
	font-size: 0.72rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.06em;
	background: #dcfce7;
	color: #15803d;
}

.update-hero-actions {
	flex-shrink: 0;
	margin-left: auto;
}

// ─── Form card ─────────────────────────────────────────────────────────────
.update-card {
	background: #fff;
	border-radius: 12px;
	border: 1px solid #e9ecef;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
	overflow: hidden;
}

.update-card-header {
	padding: 0.875rem 1.75rem;
	border-bottom: 1px solid #f1f3f5;
	font-size: 0.85rem;
	font-weight: 600;
	color: #374151;
	background: #f9fafb;
	display: flex;
	align-items: center;
}

.update-form-grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1.25rem;
	padding: 1.5rem 1.75rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
}

.update-field {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;

	&--full {
		grid-column: 1 / -1;
	}
}

.update-label {
	font-size: 0.78rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #6b7280;
	margin-bottom: 0;
}

// ─── Actions ───────────────────────────────────────────────────────────────
.update-form-actions {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 0.625rem;
	padding: 1rem 1.75rem;
	border-top: 1px solid #f1f3f5;
	background: #f9fafb;
}
</style>

